export const PATHS = {
  departments: 'departements',
  regions: 'regions',
  communes: 'communes'
};
